export const messages = {
  editor: {
    helpText: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual-shipping.help-text',
    },
    ariaLabel: {
      id: 'admin/promotions.form.regular.editor.benefit.percentual-shipping.aria-label',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.regular.view.benefit.percentual-shipping.title',
    },
  },
  validation: {
    greaterThan: {
      id: 'admin/promotions.form.validation.greater-than',
    },
    lessThanOrEquals: {
      id: 'admin/promotions.form.validation.less-than-equals',
    },
    required: {
      id: 'admin/promotions.form.validation.required',
    },
  },
}
